import React from 'react';
import { observer } from 'mobx-react';
import { Badge } from 'react-bootstrap';

import { WidgetRow } from 'src/libs/ui-kit/widget-row/WidgetRow';

import { widgetLabels } from '../constants';

import { useProfileWidgetStore } from './StoreProvider';

export const BlockingStatusRow = observer(() => {
  const { profile } = useProfileWidgetStore();
  return (
    <WidgetRow
      label={widgetLabels.profileBlockingStatus}
      value={
        profile?.isBlocked && (
          <>
            <div>
              <Badge as="span" variant="danger">
                {widgetLabels.profileBlocked}
              </Badge>
            </div>
            <div>{profile.blockingReasonDescription}</div>
            <div>{profile.blockedAt}</div>
          </>
        )
      }
    />
  );
});
